import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input as InputForm,
  InputProps as ChakraInputProps,
} from '@chakra-ui/react';
import { forwardRef, ForwardRefRenderFunction } from 'react';
import { FieldError, Merge } from 'react-hook-form';

interface InputProps extends ChakraInputProps {
  name: string;
  label?: string;
  type: string;
  error?: Merge<FieldError, undefined>;
}

const InputBase: ForwardRefRenderFunction<HTMLInputElement, InputProps> = (
  { name, label, type, error, isRequired, ...rest },
  ref,
) => {
  return (
    <FormControl isInvalid={!!error} isRequired={isRequired}>
      {!!label && (
        <FormLabel mt={'2'} htmlFor={name}>
          {label}
        </FormLabel>
      )}

      <InputForm
        type={type}
        name={name}
        id={name}
        borderRadius={'none'}
        focusBorderColor="purple.900"
        bgColor="white"
        variant="filled"
        borderColor={'black'}
        color={"#000"}
        borderWidth={'1px'}
        borderStyle="solid"
        size={'lg'}
        ref={ref}
        {...rest}
        height={'2rem'}
        minHeight={'2rem'}
        maxWidth={'100%'}
        _hover={{
          backgroundColor: 'white',
          borderColor: 'black',
        }}
      />

      {!!error && <FormErrorMessage data-test={`error-message-${error.ref?.name}`}>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};

export const InputSearch = forwardRef(InputBase);